var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Swiper',{staticClass:"brands-swiper",attrs:{"items":_vm.brands,"options":_vm.swiperOptions},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('a',{attrs:{"data-cy":"footer-brands-item","href":`/brand/${item.slug}`}},[_c('img',{attrs:{"src":item.imageUrl,"alt":`${item.slug} logo image`}})])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }